import { LOG_LEVEL_ORDER, EVENT_NAME } from './constants';
export function createLogger(target, source, module, getThreshold) {
    const log = (level, message, data, opts) => {
        if (LOG_LEVEL_ORDER[level] > LOG_LEVEL_ORDER[getThreshold()])
            return;
        const detail = {
            level,
            source,
            module,
            message,
            format: opts?.format ?? 'text',
            data,
            timestamp: performance.now(),
        };
        target.dispatchEvent(new CustomEvent(EVENT_NAME, { detail, bubbles: true }));
    };
    return {
        error: (msg, data, opts) => log('error', msg, data, opts),
        warn: (msg, data, opts) => log('warn', msg, data, opts),
        info: (msg, data, opts) => log('info', msg, data, opts),
        debug: (msg, data, opts) => log('debug', msg, data, opts),
    };
}
